<template>
  <div class="mc">
    <el-row :gutter="16" class="mc-stat">
      <el-col :xs="24" :sm="12" :lg="6">
        <div class="mc-stat__card mc-stat__card--primary">
          <div class="mc-stat__stack">
            <img class="mc-stat__ico" :src="sliceM('number.png')" alt="" role="presentation" />
            <div class="mc-stat__lab">总商户数</div>
            <div class="mc-stat__val">{{ formatInt(sum.total) }}</div>
          </div>
        </div>
      </el-col>
      <el-col :xs="24" :sm="12" :lg="6">
        <div class="mc-stat__card mc-stat__card--lite">
          <div class="mc-stat__stack">
            <img class="mc-stat__ico" :src="sliceM('amount.png')" alt="" role="presentation" />
            <div class="mc-stat__lab">商家总收款额度 (USDT)</div>
            <div class="mc-stat__val mc-stat__val--dark">{{ formatDec(sum.income) }}</div>
          </div>
        </div>
      </el-col>
      <el-col :xs="24" :sm="12" :lg="6">
        <div class="mc-stat__card mc-stat__card--lite">
          <div class="mc-stat__stack">
            <img class="mc-stat__ico" :src="sliceM('normal.png')" alt="" role="presentation" />
            <div class="mc-stat__lab">正常商户数</div>
            <div class="mc-stat__val mc-stat__val--dark">{{ formatInt(sum.normal) }}</div>
          </div>
        </div>
      </el-col>
      <el-col :xs="24" :sm="12" :lg="6">
        <div class="mc-stat__card mc-stat__card--lite">
          <div class="mc-stat__stack">
            <img class="mc-stat__ico" :src="sliceM('freeze.png')" alt="" role="presentation" />
            <div class="mc-stat__lab">冻结商户数</div>
            <div class="mc-stat__val mc-stat__val--dark">{{ formatInt(sum.frozen) }}</div>
          </div>
        </div>
      </el-col>
    </el-row>

    <div class="mc-panel">
      <div class="mc-panel__h">
        <div class="mc-panel__title">商户列表管理</div>
        <div class="mc-panel__bar">
          <div class="mc-sel-wrap">
            <el-select
              v-model="filters.status"
              class="mc-sel"
              popper-class="mc-select-popper"
              @change="load(1)"
            >
              <el-option label="全部状态" value="" />
              <el-option label="正常" value="1" />
              <el-option label="冻结" value="2" />
            </el-select>
            <img :src="sliceM(merchToolbar.select)" class="mc-sel-ico" alt="" role="presentation" />
          </div>
          <el-input
            v-model="filters.keyword"
            class="mc-search"
            clearable
            placeholder="搜索 ID / 商户名称 / 联系人"
            @keyup.enter.native="load(1)"
          >
            <span slot="prefix" class="mc-search-prefix">
              <img :src="sliceM(merchToolbar.search)" class="mc-search-ico" alt="" role="presentation" />
            </span>
          </el-input>
          <el-button type="primary" class="mc-btn-add" @click="openAdd">
            <img :src="sliceM(merchToolbar.add)" class="mc-btn-add-ico" alt="" role="presentation" />
            <span class="mc-btn-add__txt">新增商户</span>
          </el-button>
        </div>
      </div>

      <el-table v-loading="loading" :data="rows" class="mc-table" size="small" style="width: 100%">
        <el-table-column label="商户信息" min-width="180">
          <template slot-scope="s">
            <div class="mc-brand">
              <div class="mc-brand__name">{{ s.row.name }}</div>
              <div class="mc-brand__no">ID: {{ s.row.merchantNo }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="联系人 / 手机号" min-width="140">
          <template slot-scope="s">
            <div class="mc-meta">{{ s.row.contact || '—' }}</div>
            <div class="mc-meta mc-meta--sub">{{ s.row.phone || '—' }}</div>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="100">
          <template slot-scope="s">
            <span :class="['mc-st', s.row.stClass]">{{ s.row.stLabel }}</span>
          </template>
        </el-table-column>
        <el-table-column label="入驻时间" min-width="160">
          <template slot-scope="s">
            <div class="mc-time">
              <span>{{ s.row.createdAt }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="交易总额 (USDT)" min-width="130">
          <template slot-scope="s">
            <span>{{ formatDec(s.row.totalIncome) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="当前余额" min-width="120">
          <template slot-scope="s">
            <span class="mc-balance">{{ formatDec(s.row.balance) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作管理" width="130" fixed="right" align="center">
          <template slot-scope="s">
            <div class="mc-act-row">
              <button type="button" class="mc-act" title="查看" @click="openView(s.row)">
                <img :src="sliceM('view.png')" alt="查看" />
              </button>
              <button type="button" class="mc-act" title="编辑" @click="openEdit(s.row)">
                <img :src="sliceM('edit.png')" alt="编辑" />
              </button>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <div class="mc-pager">
        <span class="mc-pager__sum">显示 {{ rangeFrom }} - {{ rangeTo }} / 共 {{ total | fmtNum }} 条</span>
        <el-pagination
          background
          class="mc-pager__el"
          layout="sizes, prev, pager, next, jumper"
          :page-sizes="[10, 15, 20, 50]"
          :current-page="page"
          :page-size="pageSize"
          :total="total"
          @size-change="onSize"
          @current-change="onPage"
        />
      </div>
    </div>

    <el-dialog
      :visible.sync="dlgAdd"
      width="600px"
      custom-class="wdl-dialog wdl--merchant-view wdl--merchant-add"
      :close-on-click-modal="false"
      :show-close="false"
      @closed="resetAdd"
    >
      <div class="wdl-hero wdl-hero--sm wdl-hero--mc wdl-hero--add" :style="modalBg">
        <div class="wdl-hero__stack wdl-hero__stack--add">
          <img :src="sliceM('add_modal.png')" class="wdl-hero-add-ico" alt="" role="presentation" />
          <div class="wdl-hero-txt wdl-hero-txt--add">新增商户</div>
        </div>
        <button type="button" class="wdl-x wdl-x--round" @click="dlgAdd = false">
          <img :src="sliceCloseModal()" alt="关闭" />
        </button>
      </div>
      <div class="mc-add-body">
        <el-form ref="addForm" :model="addForm" :rules="addRules" label-position="top" size="small" class="mc-add-form">
          <el-form-item label="商户名称" prop="name" class="mc-add-item">
            <el-input v-model="addForm.name" clearable placeholder="请输入商户名称" class="mc-add-inp">
              <template slot="suffix">
                <img :src="sliceM('select.png')" class="mc-inp-ico" alt="" role="presentation" />
              </template>
            </el-input>
          </el-form-item>
          <el-row :gutter="16" class="mc-add-row2">
            <el-col :span="12">
              <el-form-item label="联系人" prop="contact" class="mc-add-item">
                <el-input v-model="addForm.contact" clearable placeholder="请输入联系人" class="mc-add-inp" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="联系电话" prop="phone" class="mc-add-item">
                <el-input v-model="addForm.phone" clearable placeholder="请输入联系电话" class="mc-add-inp" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="登录账号" class="mc-add-item">
            <el-input v-model="addForm.phone" clearable placeholder="请输入登录账号" class="mc-add-inp">
              <template slot="suffix">
                <img :src="sliceM('select.png')" class="mc-inp-ico" alt="" role="presentation" />
              </template>
            </el-input>
          </el-form-item>
          <el-form-item label="登录密码" prop="password" class="mc-add-item">
            <el-input
              v-model="addForm.password"
              type="password"
              show-password
              clearable
              placeholder="请输入登录密码"
              class="mc-add-inp"
            />
          </el-form-item>
          <div class="mc-perm mc-perm--add">
            <div class="mc-perm__ico" aria-hidden="true">
              <img :src="sliceM('permission.png')" alt="" role="presentation" />
            </div>
            <div class="mc-perm__text">
              <div class="mc-perm__title">启用账户权限</div>
              <div class="mc-perm__desc">启用后该商户下属用户可正常访问平台和 API 调用</div>
            </div>
            <el-switch
              v-model="addForm.accountEnabled"
              active-color="#2563eb"
              inactive-color="#cbd5e1"
            />
          </div>
        </el-form>
        <div class="mc-view-foot mc-add-foot">
          <el-button class="mc-view-foot__back" @click="dlgAdd = false">取消返回</el-button>
          <el-button type="primary" class="mc-view-foot__edit" :loading="addLoading" @click="submitAdd">立即保存</el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="dlgView"
      width="600px"
      custom-class="wdl-dialog wdl--merchant-view"
      :close-on-click-modal="false"
      :show-close="false"
    >
      <div v-if="viewData">
        <div class="wdl-hero wdl-hero--sm wdl-hero--mc" :style="modalBg">
          <div class="wdl-hero__stack">
            <div class="wdl-hero-txt">{{ viewData.name }}</div>
            <div class="wdl-hero-sub">ID: {{ viewData.merchant_no }}</div>
          </div>
          <button type="button" class="wdl-x wdl-x--round" @click="dlgView = false">
            <img :src="sliceCloseModal()" alt="关闭" />
          </button>
        </div>
        <div class="mc-view-body">
          <div class="mc-kv">
            <div class="mc-kv__row">
              <div class="mc-kv__cell">
                <div class="mc-kv__lab">联系人</div>
                <div class="mc-kv__val">{{ viewData.contact || '—' }}</div>
              </div>
              <div class="mc-kv__cell">
                <div class="mc-kv__lab">当前余额(USDT)</div>
                <div class="mc-kv__val mc-kv__val--primary">{{ formatDec(viewData.balance) }}</div>
              </div>
            </div>
            <div class="mc-kv__row">
              <div class="mc-kv__cell">
                <div class="mc-kv__lab">手机</div>
                <div class="mc-kv__val mc-kv__val--row">
                  <span>{{ viewData.phone || '—' }}</span>
                  <button
                    v-if="viewData.phone"
                    type="button"
                    class="mc-kv__copy"
                    title="复制"
                    @click="copyText(viewData.phone)"
                  >
                    <img :src="sliceM('copy.png')" alt="" role="presentation" />
                  </button>
                </div>
              </div>
              <div class="mc-kv__cell">
                <div class="mc-kv__lab">交易总额(USDT)</div>
                <div class="mc-kv__val">{{ formatDec(viewData.total_income) }}</div>
              </div>
            </div>
            <div class="mc-kv__row">
              <div class="mc-kv__cell mc-kv__cell--full">
                <div class="mc-kv__lab">邮箱</div>
                <div class="mc-kv__val mc-kv__val--clip">{{ viewData.email || '—' }}</div>
              </div>
            </div>
            <div class="mc-kv__row">
              <div class="mc-kv__cell mc-kv__cell--full">
                <div class="mc-kv__lab">创建时间</div>
                <div class="mc-kv__val">{{ fmtViewTime(viewData.created_at) }}</div>
              </div>
            </div>
            <div v-if="viewDataUpdated" class="mc-kv__row mc-kv__row--1">
              <div class="mc-kv__cell">
                <div class="mc-kv__lab">最后操作时间</div>
                <div class="mc-kv__val">{{ fmtViewTime(viewDataUpdated) }}</div>
              </div>
            </div>
          </div>
          <div class="mc-perm">
            <div class="mc-perm__ico" aria-hidden="true">
              <img :src="sliceM('permission.png')" alt="" role="presentation" />
            </div>
            <div class="mc-perm__text">
              <div class="mc-perm__title">启用账户权限</div>
              <div class="mc-perm__desc">启用后该商户下属用户可正常访问平台和 API 调用</div>
            </div>
            <el-switch
              v-model="viewAccountEnabled"
              :disabled="viewStatusLoading"
              active-color="#2563eb"
              inactive-color="#cbd5e1"
              @change="onViewAccountChange"
            />
          </div>
          <div class="mc-view-foot">
            <el-button class="mc-view-foot__back" @click="dlgView = false">取消返回</el-button>
            <el-button type="primary" class="mc-view-foot__edit" @click="openEditFromView">编辑信息</el-button>
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="dlgEdit"
      width="600px"
      custom-class="wdl-dialog wdl--merchant-view wdl--merchant-add"
      :close-on-click-modal="false"
      :show-close="false"
      @open="onEditOpen"
    >
      <div v-if="editForm">
        <div class="wdl-hero wdl-hero--sm wdl-hero--mc" :style="modalBg">
          <div class="wdl-hero__stack">
            <div class="wdl-hero-txt">编辑商户</div>
          </div>
          <button type="button" class="wdl-x wdl-x--round" @click="dlgEdit = false">
            <img :src="sliceCloseModal()" alt="关闭" />
          </button>
        </div>
        <div class="mc-add-body">
          <el-form ref="editFormRef" :model="editForm" :rules="editRules" label-position="top" size="small" class="mc-add-form">
            <el-form-item label="商户名称" prop="name" class="mc-add-item">
              <el-input v-model="editForm.name" clearable placeholder="请输入商户名称" class="mc-add-inp">
                <template slot="suffix">
                  <img :src="sliceM('select.png')" class="mc-inp-ico" alt="" role="presentation" />
                </template>
              </el-input>
            </el-form-item>
            <el-row :gutter="16" class="mc-add-row2">
              <el-col :span="12">
                <el-form-item label="联系人" prop="contact" class="mc-add-item">
                  <el-input v-model="editForm.contact" clearable placeholder="请输入联系人" class="mc-add-inp" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="联系电话" prop="phone" class="mc-add-item">
                  <el-input v-model="editForm.phone" clearable placeholder="请输入联系电话" class="mc-add-inp" />
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item label="登录账号" class="mc-add-item">
              <el-input v-model="editForm.phone" clearable placeholder="请输入登录账号" class="mc-add-inp">
                <template slot="suffix">
                  <img :src="sliceM('select.png')" class="mc-inp-ico" alt="" role="presentation" />
                </template>
              </el-input>
            </el-form-item>
            <el-form-item label="邮箱" class="mc-add-item">
              <el-input v-model="editForm.email" clearable placeholder="请输入邮箱" class="mc-add-inp" />
            </el-form-item>
            <el-form-item label="登录密码" class="mc-add-item">
              <el-input
                v-model="editForm.password"
                type="password"
                show-password
                clearable
                placeholder="留空表示不修改"
                class="mc-add-inp"
              />
            </el-form-item>
            <div class="mc-perm mc-perm--add">
              <div class="mc-perm__ico" aria-hidden="true">
                <img :src="sliceM('permission.png')" alt="" role="presentation" />
              </div>
              <div class="mc-perm__text">
                <div class="mc-perm__title">启用账户权限</div>
                <div class="mc-perm__desc">启用后该商户下属用户可正常访问平台和 API 调用</div>
              </div>
              <el-switch
                v-model="editStatusOn"
                active-color="#2563eb"
                inactive-color="#cbd5e1"
              />
            </div>
          </el-form>
          <div class="mc-view-foot mc-add-foot">
            <el-button class="mc-view-foot__back" @click="dlgEdit = false">取消返回</el-button>
            <el-button type="primary" class="mc-view-foot__edit" :loading="editLoading" @click="submitEdit">立即保存</el-button>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { adminApi } from '@/api/admin'

export default {
  name: 'AdminMerchantsView',
  filters: {
    fmtNum(n) {
      return Number(n || 0).toLocaleString('en-US')
    }
  },
  data() {
    return {
      sum: { total: 0, income: '0.00', normal: 0, frozen: 0 },
      /** 工具条：public/slices/merchant/select.png | search.png | add.png */
      merchToolbar: {
        select: 'select.png',
        search: 'search.png',
        add: 'add.png'
      },
      loading: false,
      page: 1,
      pageSize: 15,
      total: 0,
      rows: [],
      filters: { status: '', keyword: '' },
      dlgAdd: false,
      addLoading: false,
      addForm: {
        name: '',
        contact: '',
        phone: '',
        password: '',
        accountEnabled: true
      },
      addRules: {
        name: [{ required: true, message: '请输入商户名称', trigger: 'blur' }],
        contact: [{ required: true, message: '请输入联系人', trigger: 'blur' }],
        phone: [{ required: true, message: '请输入联系电话', trigger: 'blur' }],
        password: [{ required: true, message: '至少 6 位', trigger: 'blur' }, { min: 6, message: '至少 6 位', trigger: 'blur' }]
      },
      editRules: {
        name: [{ required: true, message: '请输入商户名称', trigger: 'blur' }],
        contact: [{ required: true, message: '请输入联系人', trigger: 'blur' }],
        phone: [{ required: true, message: '请输入联系电话', trigger: 'blur' }]
      },
      dlgView: false,
      viewData: null,
      /** 与详情 status 同步：1=开启 2=关闭，打开弹窗时赋值 */
      viewAccountEnabled: true,
      viewStatusLoading: false,
      dlgEdit: false,
      editId: null,
      editForm: null,
      editLoading: false
    }
  },
  computed: {
    rangeFrom() {
      if (!this.total) return 0
      return (this.page - 1) * this.pageSize + 1
    },
    rangeTo() {
      if (!this.total) return 0
      return Math.min(this.page * this.pageSize, this.total)
    },
    /** 与商家端提现弹窗头图一致：withdraw/address/modal_bg.png */
    modalBg() {
      return {
        backgroundImage: `url('${this.sliceAddr('modal_bg.png')}')`,
        backgroundSize: '100% 100%',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'left top'
      }
    },
    /** 详情里「最后操作」用 updated_at（若接口有返回） */
    viewDataUpdated() {
      const d = this.viewData
      if (!d) return ''
      return d.updated_at != null && d.updated_at !== '' ? d.updated_at : ''
    },
    /** 编辑弹窗内开关与 editForm.status 同步 */
    editStatusOn: {
      get() {
        if (!this.editForm) return true
        return Number(this.editForm.status) === 1
      },
      set(v) {
        if (this.editForm) this.$set(this.editForm, 'status', v ? 1 : 2)
      }
    }
  },
  created() {
    document.documentElement.style.setProperty(
      '--merch-choose',
      `url('${this.base()}slices/merchant/${encodeURIComponent(this.merchToolbar.select)}')`
    )
  },
  beforeDestroy() {
    document.documentElement.style.removeProperty('--merch-choose')
  },
  mounted() {
    this.loadSummary()
    this.load(1)
  },
  methods: {
    base() {
      return process.env.BASE_URL || '/'
    },
    sliceM(n) {
      return this.base() + 'slices/merchant/' + encodeURIComponent(n)
    },
    sliceAddr(n) {
      return this.base() + 'slices/withdraw/address/' + encodeURIComponent(n)
    },
    /** public/slices/close_modal.png */
    sliceCloseModal() {
      return this.base() + 'slices/' + encodeURIComponent('close_modal.png')
    },
    formatDec(n) {
      const x = parseFloat(n) || 0
      return x.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    },
    formatInt(n) {
      return Number(n || 0).toLocaleString('en-US')
    },
    mapRow(r) {
      const st = r.status
      const ok = st === 1
      return {
        id: r.id,
        name: r.name,
        merchantNo: r.merchant_no,
        contact: r.contact,
        phone: r.phone,
        status: st,
        stLabel: ok ? '正常' : '冻结',
        stClass: ok ? 'is-ok' : 'is-frozen',
        totalIncome: r.total_income,
        balance: r.balance,
        createdAt: this.fmtTime(r.created_at)
      }
    },
    fmtTime(t) {
      if (!t) return '—'
      return String(t).replace('T', ' ').slice(0, 19)
    },
    fmtViewTime(t) {
      return this.fmtTime(t)
    },
    copyText(t) {
      const s = (t || '').toString()
      if (!s) return
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(s).then(() => this.$message.success('已复制'))
        return
      }
      const el = document.createElement('textarea')
      el.value = s
      document.body.appendChild(el)
      el.select()
      try {
        document.execCommand('copy')
        this.$message.success('已复制')
      } catch (e) {
        this.$message.error('复制失败')
      }
      document.body.removeChild(el)
    },
    openEditFromView() {
      if (!this.viewData || this.viewData.id == null) return
      this.dlgView = false
      this.$nextTick(() => this.openEdit({ id: this.viewData.id }))
    },
    async onViewAccountChange(enabled) {
      if (!this.viewData || this.viewData.id == null) return
      const next = enabled ? 1 : 2
      const cur = Number(this.viewData.status)
      if (next === cur) return
      this.viewStatusLoading = true
      try {
        await adminApi.merchantUpdate(this.viewData.id, { status: next })
        this.$set(this.viewData, 'status', next)
        this.viewAccountEnabled = next === 1
        this.$message.success(next === 1 ? '已启用账户' : '已禁用账户')
        this.loadSummary()
        this.load(this.page)
      } catch (e) {
        this.viewAccountEnabled = cur === 1
      } finally {
        this.viewStatusLoading = false
      }
    },
    async loadSummary() {
      try {
        const r = await adminApi.merchantsSummary()
        const d = r.data || {}
        this.sum = {
          total: d.total_merchants != null ? d.total_merchants : 0,
          income: d.total_income_usdt != null ? String(d.total_income_usdt) : '0.00',
          normal: d.normal_merchants != null ? d.normal_merchants : 0,
          frozen: d.frozen_merchants != null ? d.frozen_merchants : 0
        }
      } catch (e) {
        /* 静默 */
      }
    },
    async load(p) {
      if (p) this.page = p
      this.loading = true
      try {
        const r = await adminApi.merchants({
          page: this.page,
          page_size: this.pageSize,
          status: this.filters.status,
          keyword: (this.filters.keyword || '').trim()
        })
        const d = r.data || {}
        this.total = d.total != null ? d.total : 0
        this.rows = (d.list || []).map((x) => this.mapRow(x))
      } catch (e) {
        this.rows = []
        this.total = 0
      } finally {
        this.loading = false
      }
    },
    onPage(p) {
      this.page = p
      this.load()
    },
    onSize(n) {
      this.pageSize = n
      this.load(1)
    },
    openAdd() {
      this.dlgAdd = true
    },
    resetAdd() {
      this.addForm = {
        name: '',
        contact: '',
        phone: '',
        password: '',
        accountEnabled: true
      }
      this.$nextTick(() => {
        this.$refs.addForm && this.$refs.addForm.clearValidate()
      })
    },
    submitAdd() {
      this.$refs.addForm.validate(async (ok) => {
        if (!ok) return
        this.addLoading = true
        try {
          await adminApi.merchantCreate({
            name: this.addForm.name,
            contact: this.addForm.contact,
            phone: this.addForm.phone,
            password: this.addForm.password,
            status: this.addForm.accountEnabled ? 1 : 2
          })
          this.$message.success('创建成功')
          this.dlgAdd = false
          this.loadSummary()
          this.load(1)
        } catch (e) {
          /* 错误已弹 */
        } finally {
          this.addLoading = false
        }
      })
    },
    async openView(row) {
      try {
        const r = await adminApi.merchantDetail(row.id)
        this.viewData = r.data
        const st = r.data && r.data.status
        this.viewAccountEnabled = st == null || Number(st) === 1
        this.dlgView = true
      } catch (e) {
        this.viewData = null
      }
    },
    async openEdit(row) {
      this.editId = row.id
      try {
        const r = await adminApi.merchantDetail(row.id)
        const d = r.data || {}
        this.editForm = {
          name: d.name,
          contact: d.contact,
          phone: d.phone,
          email: d.email || '',
          status: Number(d.status) === 2 ? 2 : 1,
          password: ''
        }
        this.dlgEdit = true
      } catch (e) {
        this.editForm = null
      }
    },
    onEditOpen() {
      this.$nextTick(() => {
        this.$refs.editFormRef && this.$refs.editFormRef.clearValidate()
      })
    },
    submitEdit() {
      if (!this.editId || !this.editForm) return
      this.$refs.editFormRef.validate(async (ok) => {
        if (!ok) return
        this.editLoading = true
        try {
          const body = { ...this.editForm }
          if (!body.password) delete body.password
          await adminApi.merchantUpdate(this.editId, body)
          this.$message.success('已保存')
          this.dlgEdit = false
          this.loadSummary()
          this.load(this.page)
        } catch (e) {
          /* */
        } finally {
          this.editLoading = false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.mc {
  max-width: 100%;
}
.mc-stat {
  margin-bottom: 20px;
  /* 卡片固定 262px 宽，列内水平居中，窄屏不溢出 */
  ::v-deep .el-col {
    display: flex;
    justify-content: center;
  }
}
.mc-stat__card {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 262px;
  max-width: 100%;
  height: 185px;
  padding: 24px 32px;
  box-sizing: border-box;
  border-radius: 24px;
  &--primary {
    background: linear-gradient(221deg, #0850f0 0%, #155dfc 7.39%, #00b7ff 100%);
    box-shadow: 0px 12px 40px -12px rgba(37, 99, 235, 0.3);
    color: #fff;
    .mc-stat__lab {
      color: rgba(255, 255, 255, 0.85);
    }
  }
  &--lite {
    background: rgba(255, 255, 255, 0.6);
    box-shadow: 0px 8px 32px 0px rgba(0, 0, 0, 0.02);
  }
}
/* 上：图标 / 中：标题 / 下：数值；左对齐；竖向撑满使三项分布 */
.mc-stat__stack {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  flex: 1;
  width: 100%;
  min-height: 0;
  text-align: left;
}
.mc-stat__ico {
  width: 48px;
  height: 48px;
  object-fit: contain;
  flex-shrink: 0;
  display: block;
}
.mc-stat__lab {
  font-size: 13px;
  line-height: 1.35;
  color: #64748b;
  font-weight: 500;
  width: 100%;
}
.mc-stat__val {
  font-size: 24px;
  font-weight: 800;
  line-height: 1.2;
  width: 100%;
  &--dark {
    color: #0f172a;
  }
}
.mc-stat__card--primary .mc-stat__val {
  color: #fff;
}

.mc-panel {
  background: #fff;
  border: 1px solid #f1f5f9;
  border-radius: 20px;
  padding: 16px 18px 12px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.04);
}
.mc-panel__h {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 12px;
}
.mc-panel__title {
  font-size: 16px;
  font-weight: 700;
  color: #0f172a;
  flex-shrink: 0;
}
/* 工具栏：统一高度 40px、圆角 12px、等间距，避免与 el-select 自带箭头重复 */
.mc-panel__bar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
}
.mc-sel-wrap {
  position: relative;
  width: 128px;
  flex: 0 0 auto;
  height: 40px;
}
/* 只保留设计稿里的 merchant/select.png，隐藏 Element 默认下拉箭头 */
.mc-sel {
  width: 100%;
}
.mc-sel ::v-deep .el-input__suffix {
  display: none;
}
.mc-sel ::v-deep .el-input__inner {
  height: 40px !important;
  line-height: 40px !important;
  border-radius: 12px;
  font-size: 13px;
  border: 1px solid #e2e8f0;
  background: #fff;
  padding: 0 32px 0 12px;
  box-sizing: border-box;
}
.mc-sel-ico {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  width: 16px;
  height: 16px;
  pointer-events: none;
  z-index: 2;
  object-fit: contain;
}
.mc-search {
  width: 280px;
  min-width: 160px;
  flex: 0 1 280px;
  height: 40px;
  ::v-deep .el-input {
    font-size: 13px;
  }
  ::v-deep .el-input__inner {
    height: 40px !important;
    line-height: 40px !important;
    border-radius: 12px;
    border: 1px solid #e2e8f0;
    background: #fff;
    box-sizing: border-box;
  }
  ::v-deep .el-input--prefix .el-input__inner {
    padding-left: 40px;
  }
  ::v-deep .el-input__prefix {
    left: 12px;
    display: flex;
    align-items: center;
    height: 100%;
  }
  ::v-deep .el-input__suffix {
    display: flex;
    align-items: center;
  }
}
.mc-search-prefix {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.mc-search-ico {
  width: 16px;
  height: 16px;
  object-fit: contain;
  display: block;
}
.mc-btn-add.el-button--primary {
  border-radius: 12px;
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: 40px;
  padding: 0 18px;
  margin: 0;
  box-sizing: border-box;
  line-height: 1;
  background: linear-gradient(221deg, #0850f0 0%, #155dfc 7.39%, #00b7ff 100%) !important;
  border: none !important;
  color: #fff !important;
  flex: 0 0 auto;
  /* el-button 内部包裹层，与图标+文字同一基线对齐 */
  ::v-deep > span {
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center;
    gap: 6px;
    line-height: 1;
  }
}
.mc-btn-add__txt {
  font-size: 14px;
  font-weight: 600;
  white-space: nowrap;
  line-height: 1;
  display: inline-flex;
  align-items: center;
}
.mc-btn-add-ico {
  width: 10px;
  height: 10px;
  object-fit: contain;
  flex-shrink: 0;
  display: block;
  margin: 0;
}

::v-deep .mc-table th {
  background: #f8fafc;
  color: #64748b;
  font-size: 12px;
}
.mc-brand {
  min-width: 0;
}
.mc-brand__name {
  font-weight: 600;
  color: #0f172a;
  font-size: 13px;
}
.mc-brand__no {
  font-size: 12px;
  color: #94a3b8;
  margin-top: 2px;
}
.mc-meta {
  font-size: 13px;
  color: #0f172a;
  &--sub {
    font-size: 12px;
    color: #94a3b8;
    margin-top: 2px;
  }
}
.mc-st {
  display: inline-block;
  font-size: 12px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 6px;
  &.is-ok {
    color: #059669;
    background: rgba(16, 185, 129, 0.12);
  }
  &.is-frozen {
    color: #dc2626;
    background: rgba(248, 113, 113, 0.12);
  }
}
.mc-time {
  font-size: 12px;
  color: #334155;
}
.mc-balance {
  color: #2563eb;
  font-weight: 600;
  font-size: 13px;
}
.mc-act-row {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}
.mc-act {
  padding: 0;
  margin: 0;
  background: none;
  border: none;
  cursor: pointer;
  line-height: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  vertical-align: middle;
  img {
    width: 33px;
    height: 33px;
    object-fit: contain;
    display: block;
  }
  &:hover {
    opacity: 0.85;
  }
}
.mc-pager {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  margin-top: 12px;
  padding-top: 4px;
  gap: 8px;
}
.mc-pager__sum {
  font-size: 12px;
  color: #64748b;
}
.mc-pager__el {
  ::v-deep .el-pager li.active {
    background: #3b82f6 !important;
  }
}
.mc-view-body {
  padding: 24px 32px 28px;
  background: #fff;
  box-sizing: border-box;
}
.mc-kv {
  margin-bottom: 8px;
}
.mc-kv__row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px 36px;
  margin-bottom: 22px;
  &--1 {
    grid-template-columns: 1fr;
  }
}
.mc-kv__cell--full {
  grid-column: 1 / -1;
}
@media (max-width: 560px) {
  .mc-kv__row {
    grid-template-columns: 1fr;
  }
}
.mc-kv__lab {
  font-size: 12px;
  font-weight: 500;
  color: #94a3b8;
  margin-bottom: 8px;
  line-height: 1.3;
}
.mc-kv__val {
  font-size: 15px;
  font-weight: 600;
  color: #0f172a;
  line-height: 1.45;
  word-break: break-word;
  &--primary {
    font-size: 18px;
    font-weight: 700;
    color: #2563eb;
  }
  &--row {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
  }
  &--clip {
    font-weight: 600;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
.mc-kv__copy {
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  padding: 0;
  margin: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  line-height: 0;
  &:hover {
    background: #f1f5f9;
  }
  img {
    width: 16px;
    height: 16px;
    object-fit: contain;
  }
}
.mc-perm {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  gap: 14px;
  margin-bottom: 20px;
  padding: 14px 16px;
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  box-sizing: border-box;
}
.mc-perm__ico {
  flex-shrink: 0;
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: #dbeafe;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 30px;
    height: 30px;
    object-fit: contain;
  }
}
.mc-perm__text {
  flex: 1;
  min-width: 0;
}
.mc-perm__title {
  font-size: 15px;
  font-weight: 700;
  color: #0f172a;
  line-height: 1.35;
  margin-bottom: 4px;
}
.mc-perm__desc {
  font-size: 12px;
  font-weight: 500;
  color: #64748b;
  line-height: 1.45;
}
.mc-perm .el-switch {
  flex-shrink: 0;
}
.mc-view-foot {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  box-sizing: border-box;
  gap: 12px;
  margin-top: 4px;
  padding-top: 4px;
}
.mc-view-foot .mc-view-foot__back,
.mc-view-foot .mc-view-foot__edit {
  flex: 1 1 0;
  min-width: 0;
  margin: 0 !important;
}
.mc-view-foot__back {
  min-width: 120px;
  height: 44px !important;
  padding: 0 20px !important;
  line-height: 44px !important;
  font-size: 15px;
  font-weight: 500;
  color: #64748b !important;
  background: #f1f5f9 !important;
  border: 1px solid #e2e8f0 !important;
  border-radius: 14px !important;
  &:hover {
    background: #e8eef5 !important;
  }
}
.mc-view-foot__edit {
  min-width: 120px;
  height: 44px !important;
  padding: 0 24px !important;
  line-height: 44px !important;
  font-size: 15px;
  font-weight: 600;
  border: none !important;
  border-radius: 14px !important;
  color: #fff !important;
  background: linear-gradient(221deg, #0850f0 0%, #155dfc 7.39%, #00b7ff 100%) !important;
  box-shadow: 0 2px 4px -2px rgba(43, 127, 255, 0.2), 0 4px 6px -1px rgba(43, 127, 255, 0.2);
  &:hover,
  &:focus {
    background: linear-gradient(221deg, #0646d4 0%, #0e4bdc 7.39%, #00a3e0 100%) !important;
  }
}
.mc-add-body {
  padding: 24px 32px 28px;
  background: #fff;
  box-sizing: border-box;
}
.mc-add-form {
  ::v-deep .el-form-item__label {
    color: #94a3b8;
    font-size: 13px;
    font-weight: 500;
    padding-bottom: 8px;
    line-height: 1.35;
  }
}
.mc-add-item {
  margin-bottom: 18px;
}
.mc-add-inp {
  width: 100%;
  ::v-deep .el-input__inner {
    height: 44px;
    line-height: 44px;
    border-radius: 12px;
    border-color: #e2e8f0;
    font-size: 14px;
  }
  ::v-deep .el-input__suffix {
    right: 12px;
  }
}
.mc-inp-ico {
  width: 10px;
  height: 10px;
  object-fit: contain;
  opacity: 0.5;
  display: block;
}
.mc-add-foot {
  margin-top: 12px;
  padding-top: 4px;
}
.mc-perm--add {
  margin-top: 6px;
  margin-bottom: 4px;
}
</style>

<style lang="scss">
/* 与 web-merchant-v2 提现弹窗标头/关闭（wdl-hero、wdl-x）一致 */
.wdl-dialog.wdl--merchant-view {
  border-radius: 28px;
  overflow: hidden;
  margin-top: 5vh !important;
}
.wdl-dialog.wdl--merchant-view .el-dialog__header,
.wdl-dialog.wdl--merchant-view .el-dialog__body {
  padding: 0;
}
.wdl-dialog.wdl--merchant-view .el-dialog__headerbtn {
  display: none;
}
.wdl-hero--mc {
  position: relative;
  display: flex;
  align-items: center;
  min-height: 72px;
  box-sizing: border-box;
  padding: 18px 68px 18px 24px;
  border-radius: 0;
}
.wdl-hero__stack {
  flex: 1;
  min-width: 0;
  text-align: left;
}
/* 新增商户：加号 + 标题 */
.wdl-hero--add .wdl-hero__stack--add {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
}
.wdl-hero--add .wdl-hero-add-ico {
  display: block;
  width: 32px;
  height: 32px;
  min-width: 32px;
  min-height: 32px;
  object-fit: contain;
  flex-shrink: 0;
}
.wdl-hero--mc .wdl-hero__stack .wdl-hero-txt {
  font-size: 16px;
  font-weight: 700;
  color: #0f172a;
  line-height: 1.3;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.wdl-hero-sub {
  font-size: 12px;
  font-weight: 500;
  color: #64748b;
  margin-top: 4px;
  line-height: 1.3;
}
.wdl-hero--mc .wdl-x {
  position: absolute;
  right: 14px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 3;
  width: 44px;
  height: 44px;
  margin: 0;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f9fafb;
  box-shadow: 0 1px 2px -1px rgba(0, 0, 0, 0.1), 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  border-radius: 16px;
  border: 1px solid #f3f4f6;
  box-sizing: border-box;
  cursor: pointer;
  line-height: 0;
  img {
    width: 24px;
    height: 24px;
    object-fit: contain;
  }
  &.wdl-x--round {
    border-radius: 50%;
    background: #fff;
    border: none;
    box-shadow: 0 2px 10px rgba(15, 23, 42, 0.12);
  }
}

.mc-select-popper.el-select-dropdown {
  border-radius: 10px;
  border: 1px solid #e2e8f0;
}
.mc-select-popper .el-select-dropdown__item.selected {
  color: #2563eb;
  font-weight: 600;
  position: relative;
  padding-right: 32px;
  &::after {
    content: '';
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    width: 16px;
    height: 16px;
    background: var(--merch-choose) center / contain no-repeat;
  }
}
</style>
